import { ListStore, memone } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Ping } from './Ping';

@injectable()
export class PingStore extends ListStore<Ping> {

    private get idIndex() {
        return this.buildIndexById(this.getState());
    }

    public getById(id: string): Ping {
        return this.idIndex.get(id) ?? null;
    }

    public add(ping: Ping) {
        if (this.idIndex.has(ping.id)) {
            throw new Error(`PingStore: ${ping.id} already exists?`);
        }
        this.updateState(x => x.push(ping));
        return ping;
    }

    public remove(pingOrId: Ping | string) {
        const id = typeof pingOrId === 'string' ? pingOrId : pingOrId.id;
        this.updateState(x => {
            const i = x.findIndex(p => p.id === id);
            if (i >= 0) x.splice(i, 1);
        });
    }

    @memone()
    private buildIndexById(state: Ping[]) {
        return new Map(state.map(x => [x.id, x]));
    }
}
